import { Drawer, DrawerItem, DrawerItemProps, Menu } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";
import useEventListener from "@use-it/event-listener";
import { nanoid } from "nanoid";
import React, { useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useReduxDispatch } from "../../../../redux/hooks";
import { updateIframeSrc } from "../../../../slices/RevelationSlice";
import { INavTransform } from "../../../../types/INavTransform";
import { NavItems } from "../../../../types/User/IUserProfile";
import {
  AddTextAndItemsAttrToHamburgerItems,
  trimChar,
} from "../../../../utils/utils";
import { TicketLocationState } from "../../../Ticket/TicketRoute";

export interface IHamburgerMenuProps {
  navItems: NavItems[];
  baseUrl: string;
}

export const HamburgerMenu = ({ props }: { props: IHamburgerMenuProps }) => {
  // console.log(props);
  let location = useLocation();
  let navigate = useNavigate();
  const anchor = useRef<HTMLButtonElement | null>(null);
  const menu = useRef(null);
  const [show, setShow] = useState(false);
  const dispatch = useReduxDispatch();
  //const [menuExpanded, setMenuExpanded] = React.useState(false);

  function handleItemRender(navItems: INavTransform) {
    return (
      <button
        className="flex nav-menu-button"
        key={navItems.itemId}
      >
        {navItems.item.Image_Url && <img className="w-[28px] pr-3" src={'.' + trimChar(navItems.item.Image_Url, '.')} alt={navItems.item.Text}></img>}
        {navItems.item.Text}
      </button>
    );
  }

  function handleOnClick(url: string) {
    //console.log("click", url);
    if (url) {
      if (url.indexOf("./") === 0) {
        //internal URL, not IFrame
        const ticketState = {
          background: location,
        } as unknown as TicketLocationState;
        navigate(url, { state: ticketState });
      } else {
        navigate("/");
        //console.log("dispatch", `${trimChar(props.baseUrl, "/")}${url}`);
        dispatch(
          updateIframeSrc(
            `${trimChar(props.baseUrl, "/")}${url}${url.indexOf("?") > -1 ? "&" : "?"
            }d=${nanoid()}`
          )
        );
      }
    }
    setShow(false);
  }

  const addTextAndItemsToProps = useMemo(
    () => AddTextAndItemsAttrToHamburgerItems(props.navItems),
    [props]
  );

  //Problematic in Safari
  useEventListener("click", (e: MouseEvent) => {
    //console.log('useEventListener2', e.target, (e.target as HTMLElement).className, menu?.current.element.contains(e.target as Node));

    //If anything is clicked thats not a menu item then close the menu
    if (!menu?.current?.element?.contains(e.target as Node) && (e.target as HTMLElement).className?.indexOf && (e.target as HTMLElement).className?.indexOf('burger-menu-icon') == -1 && show !== false) {
      console.log('closing menu')
      setShow(false);
    }
  });

  const RenderItem = (props: DrawerItemProps) => {
    return (
      <DrawerItem {...props} title={props.text} style={{ background: '#868586', color: '#fff' }}>
        <div className="flex">
          {props.image
            ? <img alt="Tool" src={props.image} style={{ maxHeight: 20, marginLeft: 7, marginRight: 3 }} />
            : <span className={"k-font-icon " + props.icon} />
          }
          <div className="k-item-text">
            {props.text}
          </div>
          <span
            className={"k-font-icon k-i-arrow-chevron-right flex-grow"}
            style={{
              position: "absolute",
              right: 0,

            }}
          />

        </div>
      </DrawerItem>
    );
  };



  return (
    <>
      <div className="relative" title="Navigation">
        <button
          className="bg-[#868586] grid place-content-center z-50 w-[30px] h-[30px]"
          onClick={() => {
            setShow(!show)
            menu?.current?.element.focus();
            console.log('focused', menu, menu?.current);
          }}
          onBlur={e => {
            console.log('Blur', e);
            //if (e.relatedTarget.className.indexOf("nav-menu-button") == -1)
            //setShow(false);
          }}
          ref={anchor}
        >
          <img
            className="p-1 burger-menu-icon"
            src={"./images/Hamburger_icon.png"}
            alt="menu button"
            width={23}
          />
        </button>
      </div>

      <Popup
        className="nav-burger-popup"
        anchor={anchor.current}
        show={show}
        style={{ position: "absolute", zIndex: 120 }}
        anchorAlign={{ horizontal: "right", vertical: "bottom" }}
        popupAlign={{ horizontal: "right", vertical: "top" }}
      >
        <Menu ref={menu}
          className="nav-burger-menu"
          vertical
          itemRender={(item: INavTransform) => handleItemRender(item)}
          items={addTextAndItemsToProps}
          onSelect={(e) => {
            const navItem: NavItems = e.item as NavItems;
            handleOnClick(navItem.Url);
          }}
          hoverCloseDelay={2000}
        // For Debugging
        // hoverCloseDelay={1000 * 60 * 60}
        />
      </Popup>
      {/* Experimental */}
      {/* <Drawer
        expanded={false}
        position="end"
        mode="overlay"
        mini={false}
        width={200}
        items={props.navItems.map(n => {
          return {
            text: n.Text,
            image: n.Image_Url,
            selected: true,
            route: "/",
          }
        })}
        item={RenderItem}
      ></Drawer> */}
    </>
  );
};
